var React = require('react');

function Check8x8 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Inverted=off, Size=8x8"},React.createElement("path",{"id":"Vector 199","d":"M1.333 3.42l2.445 3.247 2.889-5.334","stroke":"currentColor","strokeLinecap":"round"})));
}

Check8x8.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = Check8x8;

Check8x8.default = Check8x8;
